export default {
  /*更新webSocket推送消息内容*/
  UPDATENEWNOTIFY (state,news) {
    if (news.type === 1) {      
      window.localStorage.setItem('news',news);                  //1、微信绑定
      // let avatarTemp = news.wechatUserImg.split('/')
      // avatarTemp[avatarTemp.length - 1] = '0'          //修改头像图片地址的最后一个参数
      state.wechatInfo = {
        // avatar: avatarTemp.join('/'),
        // nickName: news.data.wechatUserNickName,
        openid: news.openid
      }
    } else {                                          //2、其他推送消息在右下角提示
      state.newMessageInform = {
        type: news.type,
        title: news.msgTitle,
        content: news.msgContent,
        verify: news.verify,
        money: news.money,
      }
    }
  },
  /*更新数据库所有省份数据*/
  UPDATEPROVINCE (state,arr) { state.provinceArr = arr; },
  /*更新数据库某一省份下所有的市*/
  UPDATECITY (state,arr) { state.cityArr = arr; },
  /*更新数据库某一市下所有的区*/
  UPDATEDISTRICT (state,arr) { state.districtArr = arr; },
}
